import { EyeInvisibleOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import { usePalette } from "@/shared/theme";
import { Hidden } from "gql/graphql";

/**
 * «Значение есть, но не для вас». Отличается от пустоты намеренно: пустое поле показывает
 * «не указано», скрытое — эту плашку, с именем объекта, если защита его отдала.
 */
export function HiddenLabel({ data }: { data?: Hidden }) {
  const t = useTranslations("Common");
  const palette = usePalette();
  const instanceName = data?.instanceName;

  return (
    <span
      data-testid="hidden-value"
      title={instanceName ? t("Hidden") : undefined}
      style={{
        background: palette.neutral[2],
        padding: "4px",
        borderRadius: "4px",
      }}
    >
      <EyeInvisibleOutlined /> {instanceName || t("Hidden")}
    </span>
  );
}
